import React from 'react';


const AboutUsTopBannerPreview = ({topBannerImage}) => {
  return (
    <div className="pb-5">
      <img
        src={topBannerImage}
        className="w-full"
        alt="About Us Page Top Banner"
      />
    </div>
  );
};

export default AboutUsTopBannerPreview;
